import { withEffects } from 'mixins/withEffects';
import QualzyVideoPickerManager from './videoUploaders/qualzyVideoPickerManager';
// import { FilesHelpers } from 'helpers/files';
// import WCCS3VideoUploader from './uploads/s3/video';
// import WCCVideoPickerManager from './wccVideoPicker';

//const { allowedUploadVideoExtensions } = settings;

export interface GenericVideoPickerManagerConfig {
    key?: string
}

export default class GenericVideoPickerManager {
    private effects = withEffects()

    // private videoUploader: WCCS3VideoUploader
    // private wccVideoPicker: WCCVideoPickerManager
    private qualzyVideoPicker: QualzyVideoPickerManager

    constructor(config: GenericVideoPickerManagerConfig = {}) {
        // this.videoUploader = new WCCS3VideoUploader({ key: config.key });
        // this.wccVideoPicker = new WCCVideoPickerManager({ key: config.key });
        this.qualzyVideoPicker = new QualzyVideoPickerManager({ key: config.key });
    }

    async pick() {
        return this.qualzyVideoPicker.pick();
        // if (settings.proxyTaskResources) {
        //     return await this.wccVideoPicker.pick();
        // }
        // else {
        //     return await this.videoUploader.upload(await FilesHelpers.pickFile(true, allowedUploadVideoExtensions));
        // }
    }

    dispose() {
        this.effects.dispose();
    }
}